/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldPlacement } from './FieldPlacement';
import {
    FieldPlacementFromJSON,
    FieldPlacementFromJSONTyped,
    FieldPlacementToJSON,
    FieldPlacementToJSONTyped,
} from './FieldPlacement';

/**
 * 
 * @export
 * @interface GetFormByTokenResponseTemplate
 */
export interface GetFormByTokenResponseTemplate {
    /**
     * 
     * @type {string}
     * @memberof GetFormByTokenResponseTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetFormByTokenResponseTemplate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFormByTokenResponseTemplate
     */
    category?: string | null;
    /**
     * URL to fetch the PDF template
     * @type {string}
     * @memberof GetFormByTokenResponseTemplate
     */
    pdfTemplateUrl: string;
    /**
     * Field placement definitions for the form
     * @type {Array<FieldPlacement>}
     * @memberof GetFormByTokenResponseTemplate
     */
    fieldPlacements?: Array<FieldPlacement>;
}

/**
 * Check if a given object implements the GetFormByTokenResponseTemplate interface.
 */
export function instanceOfGetFormByTokenResponseTemplate(value: object): value is GetFormByTokenResponseTemplate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('pdfTemplateUrl' in value) || value['pdfTemplateUrl'] === undefined) return false;
    return true;
}

export function GetFormByTokenResponseTemplateFromJSON(json: any): GetFormByTokenResponseTemplate {
    return GetFormByTokenResponseTemplateFromJSONTyped(json, false);
}

export function GetFormByTokenResponseTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFormByTokenResponseTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'pdfTemplateUrl': json['pdfTemplateUrl'],
        'fieldPlacements': json['fieldPlacements'] == null ? undefined : ((json['fieldPlacements'] as Array<any>).map(FieldPlacementFromJSON)),
    };
}

export function GetFormByTokenResponseTemplateToJSON(json: any): GetFormByTokenResponseTemplate {
    return GetFormByTokenResponseTemplateToJSONTyped(json, false);
}

export function GetFormByTokenResponseTemplateToJSONTyped(value?: GetFormByTokenResponseTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'category': value['category'],
        'pdfTemplateUrl': value['pdfTemplateUrl'],
        'fieldPlacements': value['fieldPlacements'] == null ? undefined : ((value['fieldPlacements'] as Array<any>).map(FieldPlacementToJSON)),
    };
}

